<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Complaint Media Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Complaint Media</label>
                <input type="text" class="form-control" id="name" v-model="cm.name">
                <!-- <input type="text" class="form-control" v-model="mm.module" id="module" aria-describedby="module"> -->
                <!-- <select type = "dropdown" class="form-control" id="module" v-model="mm.module">
                    <option v-for="(list, index) in this.moduleLists" :key="index" :value="list.value">{{ list.title }}</option>
                </select> -->
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../services/api'
import { complaintMedia } from '../models/complaintMedia'
import AppLookupField from '../components/AppLookupField.vue'
import AppDatePicker from '../components/AppDatePicker.vue'
import AppNavBar from '../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar
    },
    data() {
        return {
            cm: {...complaintMedia},
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const cmApi = api('complaint-media')
            this.cm = await cmApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async save() {
            const cmApi = api('complaint-media')
            if(this.$route.query.id !== undefined) {
                await cmApi.update(this.cm, this.$route.query.id)
            } else {
                await cmApi.create(this.cm)
                
            }
            this.$router.go(-1)
        },
        cancel() {
            this.$router.go(-1)
        },
    }
}
</script>